import { createListenerMiddleware } from "@reduxjs/toolkit"
import { addChoice, setMessages } from "./simulationSlice"
import { choiceToEvent, currentCrisisStatus } from "./utils"
import { RootState } from "../../app/store" // Adjust the import based on your project structure

const listenerMiddleware = createListenerMiddleware()

listenerMiddleware.startListening({
  actionCreator: addChoice,
  effect: async (action, listenerApi) => {
    const state = listenerApi.getState() as RootState
    const { choiceType } = action.payload

    const sortedItems = state.simulationSlice.messages
      .filter(
        (item) =>
          item.type === (choiceType === "decision" ? "decision" : "cplan"),
      )
      .sort((a, b) => {
        if (choiceType === "decision") {
          return a.decisionId !== undefined && b.decisionId !== undefined
            ? Number(a.decisionId) - Number(b.decisionId)
            : 0
        } else {
          return a.planId && b.planId ? a.planId - Number(b.planId) : 0
        }
      })

    const event = choiceToEvent(
      action.payload,
      state.simulationSlice.secondsElapsed,
      sortedItems,
      currentCrisisStatus(state.simulationSlice),
    )

    if (choiceType !== "eplan") {
      const newMessages = [...state.simulationSlice.messages, event]
      listenerApi.dispatch(setMessages(newMessages))
    } else {
      const updatedMessages = state.simulationSlice.messages.map((message) =>
        message.id === event.id
          ? {
              ...event,
              mode: "eplan",
              planId: state.simulationSlice.messages.find(
                (item) => item.id === event.id,
              )?.planId,
            }
          : message,
      )
      listenerApi.dispatch(setMessages(updatedMessages))
    }
  },
})

export default listenerMiddleware
